import {
	CHANGE_SELECTED_SOLICITOR_USERS,
	CHANGE_SOLICITOR_USERS_LIST_SETTINGS,
	CHANGE_SOLICITOR_DISPLAYED_USERS,
	CHECK_ALL_SOLICITOR_USERS,
	CHECK_SOLICITOR_USER,
	TOGGLE_MODAL,
	FILTER_BY_LAWSYS,
	RECEIVE_GET_SOLICITORS,
	SOLICITOR_USERS_AGENTS_FILTER,
	SOLICITOR_USERS_PAGE_SHIFT,
	CHANGE_LAWSYS_ID,
	LOGOUT,
	TOGGLE_CONFIRM_DIALOG,
	REQUEST_GET_SOLICITORS,
	RECEIVE_BAD_REQUEST_GET_SOLICITORS,
	RECEIVE_POST_NEW_SOLICITOR_RESPONSE,
	CHANGE_AGENTS_LIST_SETTINGS,
	CHANGE_FIELD,
	CREATED_SOLICITOR_GROUP_RESPONSE,
	RECEIVE_PATCH_EXISTING_SOLICITOR_RESPONSE,
	RECEIVE_BAD_REQUEST_PATCH_EXISTING_SOLICITOR,
	RECEIVE_GET_SOLICITORS_SUGGESTIONS,
	GET_SOLICITOR_USER_COLLEAGUES,
	GET_SOLICITOR_USER_COLLEAGUES_SUCCESS, GET_SOLICITOR_USER_COLLEAGUES_FAILED
} from "../actions/index";
import _ from 'lodash';
import {IsJsonString} from "../helpers/functions";
import {SORT_AGENTS_LIST} from "../actions";

const defaultState = {
    allSolicitorUsers: [],
    selectedSolicitorUsers: {},
    solicitorUserSearchForm: "",
    allSolicitorsChecked: false,
    solicitorUsersListSettings: {
        displayAmount: 20,
        page: 1,
        value: '',
        suggestions: [],
        action: "",
		sortBy: 'name',
        sortOrder: 'asc'
    },
    displayedUsers: [],
    lawsys: [],
    displayModal: false,
    changeLawsys: false,
    selectedLawsysId: "",
    selectedLawsys: null,
    displayConfirm: false,
    attachLawsysMsg: "",
    filterBySolicitor: "noFilter",
    filterBySolicitorFirm: null,
    fetching: false,
    badFetchResponse: '',
    solicitorNotInGroup: false,
    openNewSolicitorGroupModal: false,
    badPatchResponse: '',
    failedToChangeStatusMsg: '',
    suggestions: [],
};

export default (state = defaultState, action) => {
	switch (action.type) {
		case GET_SOLICITOR_USER_COLLEAGUES:
			return {
				...state,
				fetching: true
			};
		case GET_SOLICITOR_USER_COLLEAGUES_SUCCESS:
			return {
				...state,
				displayedUsers: action.payload.body,
				fetching: false
			};
		case GET_SOLICITOR_USER_COLLEAGUES_FAILED:
			return {
				...state,
				fetching: false
			};
		case SORT_AGENTS_LIST:
			let newOrder = state.solicitorUsersListSettings.sortOrder;
			if(action.payload === state.solicitorUsersListSettings.sortBy){
				newOrder = state.solicitorUsersListSettings.sortOrder === 'desc' ? 'asc' : 'desc';
			} else {
				newOrder = 'desc';
			}

			return {
                ...state,
                solicitorUsersListSettings: {
                    ...state.solicitorUsersListSettings,
                    sortBy : action.payload,
					sortOrder: newOrder
                }
			};
		case RECEIVE_BAD_REQUEST_PATCH_EXISTING_SOLICITOR:
			if (action.payload === 'Email is already taken')
				return {
					...state,
					badPatchResponse:IsJsonString(action.payload.text)?JSON.parse(action.payload.text): 'Email is already taken.',
				};
			else if (action.payload === 'Username is already taken') {
				return {
					...state,
					badPatchResponse: IsJsonString(action.payload.text)?JSON.parse(action.payload.text): 'Username is already taken.',
				};
			}
			else if (action.payload === 'Username and/or Email are already taken') {
				return {
					...state,
					badPatchResponse: IsJsonString(action.payload.text)?JSON.parse(action.payload.text): 'Username and/or Email are already taken.',
				};
			}
			else
				return {
					...state,
					badPatchResponse: IsJsonString(action.payload.text)?JSON.parse(action.payload.text): 'Failed to update solicitor user.',
				};
		case CREATED_SOLICITOR_GROUP_RESPONSE:
			return {
				...state,
				openNewSolicitorGroupModal: false,
				solicitorNotInGroup: false
			};
		case CHANGE_FIELD:
			return {
				...state,
				openNewSolicitorGroupModal: false
			};
		case CHANGE_AGENTS_LIST_SETTINGS:
			return {
				...state,
				[action.payload.key]: action.payload.value,
				badPatchResponse: ''
			};
		case RECEIVE_PATCH_EXISTING_SOLICITOR_RESPONSE:
			let newDisplayedUsers = [...state.displayedUsers];
			for (let i = 0; i < state.displayedUsers.length; i++) {
				if (state.displayedUsers[i].id === action.payload.id) {
					if (Object.keys(state.selectedSolicitorUsers).length > 0) {
						newDisplayedUsers[i] = {...action.payload, id: action.payload.id};
					}
					else {
						if (i !== 0) {
							let swapFirstItem = newDisplayedUsers[0];
							newDisplayedUsers[0] = {...action.payload, id: action.payload.id};
							newDisplayedUsers[i] = swapFirstItem;
						}
						else {
							newDisplayedUsers[0] = {...action.payload, id: action.payload.id};
						}
					}
				}
			}
			for (let i = 0; i < state.allSolicitorUsers.length; i++) {
				if (state.allSolicitorUsers[i].id === action.payload.id) {
					let newSolicitorUsers = [...state.allSolicitorUsers];
					if (Object.keys(state.selectedSolicitorUsers).length > 0) {
						newSolicitorUsers[i] = {...action.payload, id: action.payload.id};
					}
					else {
						if (i !== 0) {
							let swapFirstItem = newSolicitorUsers[0];
							newSolicitorUsers[0] = {...action.payload, id: action.payload.id};
							newSolicitorUsers[i] = swapFirstItem;
						}
						else {
							newSolicitorUsers[0] = {...action.payload, id: action.payload.id};
						}
					}
					return {
						...state,
						selectedSolicitorUsers: {},
						allSolicitorsChecked: false,
						allSolicitorUsers: newSolicitorUsers,
						displayedUsers: newDisplayedUsers,
						displayModal: false,
						displayConfirm: false,
						solicitorNotInGroup: false,
						openNewSolicitorGroupModal: false
					}
				}
			}
			return {
				...state,
				allSolicitorUsers: [action.payload, ...state.allSolicitorUsers],
				displayedUsers: [action.payload, ...state.displayedUsers]
			};
		case RECEIVE_POST_NEW_SOLICITOR_RESPONSE:
			return {
				...state,
				allSolicitorUsers: [action.payload, ...state.allSolicitorUsers],
				displayedUsers: [action.payload, ...state.displayedUsers]
			};
		case CHECK_SOLICITOR_USER: {
			let selectedNewItems = {};
			if (action.payload.checked) {
				selectedNewItems = { ...state.selectedSolicitorUsers, [action.payload.rowIndex]: action.payload.row }

			} else {
				selectedNewItems = _.omit(state.selectedSolicitorUsers, [action.payload.rowIndex]);
			}

			return {
				...state,
				selectedSolicitorUsers: selectedNewItems,
			};
		}
		case CHANGE_SOLICITOR_DISPLAYED_USERS:
			return {
				...state,
				displayedUsers: action.payload
			};
		case CHECK_ALL_SOLICITOR_USERS:
			let selected = {};
			if (action.payload) {
				state.allSolicitorUsers.forEach((claim, index) => {
					selected = { ...selected, [index]: claim };
				});
			}

			return {
				...state,
				selectedSolicitorUsers: selected
			};
		case CHANGE_SOLICITOR_USERS_LIST_SETTINGS: {
			if (action.payload.key === 'displayAmount') {
				return {
					...state,
					solicitorUsersListSettings: {
						...state.solicitorUsersListSettings,
						[action.payload.key]: action.payload.value,
						page: 1
					},
					selectedSolicitorUsers: {},
					allSolicitorsChecked: false
				}
			}
			else if (action.payload.key === 'page')
				return {
					...state,
					solicitorUsersListSettings: {
						...state.solicitorUsersListSettings,
						[action.payload.key]: parseInt(action.payload.value)
					},
					selectedSolicitorUsers: {},
					allSolicitorsChecked: false
				};
			else {
				return {
					...state,
					solicitorUsersListSettings: {
						...state.solicitorUsersListSettings,
						[action.payload.key]: action.payload.value,
					}
				}
			}
		}
		case SOLICITOR_USERS_PAGE_SHIFT: {
			if (action.payload === 'left' && state.solicitorUsersListSettings.page > 1) {
				return {
					...state,
					solicitorUsersListSettings: {
						...state.solicitorUsersListSettings,
						page: state.solicitorUsersListSettings.page - 1
					},
					selectedSolicitorUsers: {},
					allSolicitorsChecked: false
				}
			}
			else if (action.payload === 'right' && state.solicitorUsersListSettings.page < state.solicitorUsersListSettings.totalBoxes) {
				return {
					...state,
					solicitorUsersListSettings: {
						...state.solicitorUsersListSettings,
						page: state.solicitorUsersListSettings.page + 1
					},
					selectedSolicitorUsers: {},
					allSolicitorsChecked: false
				}
			}
			else {
				return state
			}
		}
		case SOLICITOR_USERS_AGENTS_FILTER: {
			if (action.payload.length === 0) {
				return {
					...state,
					displayedUsers: state.allSolicitorUsers,
					selectedSolicitorUsers: {},
					allSolicitorsChecked: false,
					filterBySolicitor: 'noFilter'
				}
			}
			else {
				return {
					...state,
					displayedUsers: action.payload,
					solicitorUsersListSettings: {...state.solicitorUsersListSettings, page: 1},
					selectedSolicitorUsers: {},
					allSolicitorsChecked: false,
					filterBySolicitor: 'noFilter'
				};
			}
		}
		case CHANGE_SELECTED_SOLICITOR_USERS:
			if (action.payload === 'enable') {
				let updatedUsers = {};
				for (let index in state.selectedSolicitorUsers) {
					updatedUsers[index] = {
						...state.selectedSolicitorUsers[index],
						status: true
					}
				}
				return {
					...state,
					selectedSolicitorUsers: {...updatedUsers},
					changeLawsys: false,
					selectedLawsysId: "",
					solicitorUsersListSettings: {...state.solicitorUsersListSettings, action: action.payload}
				};
			}
			else if (action.payload === 'disable') {
				let updatedUsers = {};
				for (let index in state.selectedSolicitorUsers) {
					updatedUsers[index] = {
						...state.selectedSolicitorUsers[index],
						status: false
					}
				}
				return {
					...state,
					selectedSolicitorUsers: {...updatedUsers},
					changeLawsys: false,
					selectedLawsysId: "",
					solicitorUsersListSettings: {...state.solicitorUsersListSettings, action: action.payload}
				};
			}
			else if (action.payload === 'changeLawsys') {
				return {
					...state,
					changeLawsys: true,
					solicitorUsersListSettings: {...state.solicitorUsersListSettings, action: action.payload}
				}
			}
			else
				return {
					...state,
					solicitorUsersListSettings: {...state.solicitorUsersListSettings, action: ""}
				};
		case RECEIVE_GET_SOLICITORS:
			let totalDisplayBoxes = Math.ceil(action.payload.totalRecords / parseInt(state.solicitorUsersListSettings.displayAmount));
			let currentPage = parseInt(state.solicitorUsersListSettings.page);
			if(currentPage > totalDisplayBoxes && totalDisplayBoxes !== 0){
				currentPage = totalDisplayBoxes;
			}
			return {
				...state,
				allSolicitorUsers: action.payload.data,
				displayedUsers: action.payload.data,
				fetching: false,
				solicitorUsersListSettings: {
					...state.solicitorUsersListSettings,
					totalBoxes: totalDisplayBoxes,
					totalRecords: action.payload.totalRecords,
					page: currentPage,
					suggestions: []
				}
			};
		case REQUEST_GET_SOLICITORS:
			return {
				...state,
				fetching: true,
				solicitorUsersListSettings: {
					...state.solicitorUsersListSettings,
					suggestions: []
				}
			};
		case RECEIVE_BAD_REQUEST_GET_SOLICITORS:
			return {
				...state,
				fetching: false,
				badFetchResponse: action.payload,
				solicitorUsersListSettings: {
					...state.solicitorUsersListSettings,
					suggestions: []
				}
			};
		case RECEIVE_GET_SOLICITORS_SUGGESTIONS:
			return {
				...state,
				solicitorUsersListSettings: {
					...state.solicitorUsersListSettings,
					suggestions: action.payload.data
				}
			};
		case FILTER_BY_LAWSYS: {
			if (action.payload !== 'noFilter') {
				let filteredUsers = [];
				filteredUsers = state.allSolicitorUsers.filter((value) => value.lawsysId === parseInt(action.payload))
				return {
					...state,
					displayedUsers: filteredUsers,
					selectedSolicitorUsers: {},
					allSolicitorsChecked: false,
					solicitorUsersListSettings: {...state.solicitorUsersListSettings, page: 1, value: ''},
					filterBySolicitor: action.payload
				}
			}
			else
				return {
					...state,
					displayedUsers: state.allSolicitorUsers,
					selectedSolicitorUsers: {},
					allSolicitorsChecked: false,
					solicitorUsersListSettings: {...state.solicitorUsersListSettings, page: 1},
					filterBySolicitor: 'noFilter'
				}
		}
		case TOGGLE_MODAL:
			return {
				...state,
				displayModal: !state.displayModal,
				displayConfirm: false,
				openNewSolicitorGroupModal: false,
				selectedLawsysId: '',
				selectedLawsys: null,
				solicitorNotInGroup: false
			};
		case CHANGE_LAWSYS_ID:
			let lawsysFirmIndex = _.findIndex(action.payload.allFirms, {id: parseInt(action.payload.id)});
			return {
				...state,
				selectedLawsysId: action.payload.id,
				selectedLawsys: {
					...state.selectedLawsys,
					lawsysId: action.payload.id,
					lawsysName: action.payload.name,
					addressLine1: action.payload.allFirms[lawsysFirmIndex].address,
					postcode: action.payload.allFirms[lawsysFirmIndex].postcode,
					aragProvider: action.payload.aragProvider
				}
			};
		case LOGOUT:
			return {
				...defaultState
			};
		case TOGGLE_CONFIRM_DIALOG :
			return {
				...state,
				displayConfirm: !state.displayConfirm
			};
		case '@@router/LOCATION_CHANGE':
			return {
				...defaultState,
				allSolicitorUsers: state.allSolicitorUsers,
				displayedUsers: state.displayedUsers,
				solicitorUsersListSettings: state.solicitorUsersListSettings,
				filterBySolicitor: state.filterBySolicitor,
				filterBySolicitorFirm: state.filterBySolicitorFirm,
                changeLawsys: state.changeLawsys
			};
		default :
			return state
	}
}